import { Observable, of, Subscription } from "rxjs";
import DigitalDataService from "./digitalDataService";

let _visitId = "";
const _documentListeners: string[] = [];
const KEY_PREFIX = "wbm_rh_vid_";
const NotificationsAlertTimeKey = "NotificationsAlertTime";
const NotificationsAlertShakeCountKey = "NotificationsAlertTimeShakeCount";
const NotificationsBellCountKey = "NotificationsBellCount";

export function setVisitId(visitId: string) {
  _visitId = visitId + "_" + DigitalDataService.userConfigId();

  if (typeof sessionStorage !== "undefined") {
    // remove any other user's info
    Object.keys(sessionStorage).forEach((key) => {
      if (
        key.startsWith(KEY_PREFIX) &&
        !key.startsWith(KEY_PREFIX + _visitId)
      ) {
        sessionStorage.removeItem(key);
      }
    });
  }
}

function updateSessionCache<T>(
  key: string,
  request: Observable<T>,
  callback: (response: T) => void
) {
  sessionStorage.removeItem(key);
  return request.subscribe((response) => {
    callback(response);
    sessionStorage.setItem(key, JSON.stringify(response));
  });
}
const SessionCacheService = {
  set: (key: string, value: unknown) => {
    const fullKey = KEY_PREFIX + _visitId + "|" + key;

    if (
      value !== null ||
      value !== false ||
      value !== "" ||
      value !== undefined ||
      !isNaN(value)
    ) {
      sessionStorage.setItem(fullKey, JSON.stringify(value));
    } else {
      sessionStorage.removeItem(fullKey);
    }
  },
  getValue: (key: string) => {
    if (typeof sessionStorage === "undefined") {
      return "";
    }

    const fullKey = KEY_PREFIX + _visitId + "|" + key;

    const value = sessionStorage.getItem(fullKey);

    if (value) {
      return JSON.parse(value);
    }

    return value;
  },
  clear: () => {
    Object.keys(sessionStorage).forEach((key) => {
      if (key.startsWith(KEY_PREFIX)) {
        if (
          key.endsWith(NotificationsAlertTimeKey) ||
          key.endsWith(NotificationsAlertShakeCountKey) ||
          key.endsWith(NotificationsBellCountKey)
        ) {
          return;
        }
        sessionStorage.removeItem(key);
      }
    });
  },
  get<T>(
    key: string,
    request: Observable<T>,
    callback: (response: T) => void,
    errorCallBack?: (error: any) => void
  ): Subscription {
    const fullKey = KEY_PREFIX + _visitId + "|" + key;
    const result = sessionStorage.getItem(fullKey);
    let subscription: Subscription;
    if (
      result === undefined ||
      result === null ||
      result === "" ||
      result === "[]"
    ) {
      subscription = request.subscribe(
        (response) => {
          sessionStorage.setItem(fullKey, JSON.stringify(response));
          callback(response);
        },
        (error: any) => {
          if (errorCallBack) {
            errorCallBack(error);
          }
        }
      );
    } else {
      const resultObject = JSON.parse(result);
      callback(resultObject);
      subscription = of().subscribe();
    }

    if (!_documentListeners.includes(key)) {
      _documentListeners.push(key);
      document.addEventListener(key, () => {
        const internalFullKey = KEY_PREFIX + _visitId + "|" + key;
        updateSessionCache(internalFullKey, request, callback);
      });
    }

    return subscription;
  },
};

export default SessionCacheService;
